"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbPagination = exports._SbPagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("../../skybase-core/shapes");

var _keyCodes = require("../../skybase-core/constants/keyCodes");

var _sbButton = require("../sb-button");

var _sbTextbox = require("../sb-textbox");

var _sbPaginationI18n = require("./sb-pagination-i18n");

var _utils = require("./utils");

var _sbDropdown = require("../sb-dropdown");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var pageSizesShape = {
  value: _propTypes.default.number,
  label: _propTypes.default.string
};

var _SbPagination = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbPagination, _PureComponent);

  var _super = _createSuper(_SbPagination);

  function _SbPagination(props) {
    var _this;

    _classCallCheck(this, _SbPagination);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnPageNumberChange", function (value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          pageSize = _this$props.pageSize;
      onChange({
        pageSize: pageSize,
        pageNumber: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPageSizeChange", function (value) {
      var onChange = _this.props.onChange;
      onChange({
        pageSize: parseInt(value, 10),
        pageNumber: 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnGoToPageInputChange", function (event, formattedValue) {
      _this.setState({
        goToPageValue: formattedValue.floatValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnGoToPageClick", function () {
      var goToPageValue = _this.state.goToPageValue;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          pageSize = _this$props2.pageSize;

      var maxLength = _this.getChunks().length;

      onChange({
        pageSize: pageSize,
        pageNumber: typeof goToPageValue === 'number' ? goToPageValue : maxLength
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNavigationChange", function (_ref) {
      var value = _ref.value,
          isControl = _ref.isControl;
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          pageNumber = _this$props3.pageNumber,
          pageSize = _this$props3.pageSize;

      if (isControl) {
        onChange({
          pageSize: pageSize,
          pageNumber: pageNumber + value
        });
      } else {
        _this.handleOnPageNumberChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderControls", function () {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-pagination-controls"
      }, _this.renderPageSize(), _this.renderNavigation());
    });

    _defineProperty(_assertThisInitialized(_this), "limit", function (val) {
      var max = _this.getChunks().length;

      var parsedVal = parseInt(val, 10);

      if (parsedVal > max) {
        return "".concat(max);
      }

      if (parsedVal === 0) {
        return '1';
      }

      return val;
    });

    _defineProperty(_assertThisInitialized(_this), "getChunks", function () {
      var _this$props4 = _this.props,
          pageSize = _this$props4.pageSize,
          totalCount = _this$props4.totalCount;
      return (0, _utils.chunkItems)({
        pageSize: pageSize,
        totalCount: totalCount
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderGoToPage", function (isSoloPage) {
      var _this$props5 = _this.props,
          disabled = _this$props5.disabled,
          goToPageLabel = _this$props5.goToPageLabel,
          goToPageInputProps = _this$props5.goToPageInputProps,
          _ = _this$props5.intl.formatMessage;
      var goToPageValue = _this.state.goToPageValue;

      var maxLength = _this.getChunks().length;

      var _ref2 = goToPageInputProps !== null && goToPageInputProps !== void 0 ? goToPageInputProps : {},
          style = _ref2.style,
          restGoToPageInputProps = _objectWithoutProperties(_ref2, ["style"]);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pagination-go-to-page"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "go-to-page-label"
      }, goToPageLabel || _(_sbPaginationI18n.messages.goToPageLabel)), /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({}, restGoToPageInputProps, {
        style: (0, _utils.setInputStyle)(style),
        outerClassName: "go-to-page-input",
        type: "number",
        onKeyUp: function onKeyUp(event) {
          if (event.keyCode === _keyCodes.enter) {
            _this.handleOnGoToPageClick(event);
          }
        },
        onChange: _this.handleOnGoToPageInputChange,
        disabled: disabled || isSoloPage,
        fraction: 0,
        negative: false,
        format: _this.limit,
        value: goToPageValue || maxLength
      })), /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: _this.handleOnGoToPageClick,
        className: (0, _classnames.default)('sb-btn'),
        disabled: disabled || isSoloPage
      }, '>'));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageSize", function () {
      var _pageSizeDropdownProp;

      var _this$props6 = _this.props,
          pageSize = _this$props6.pageSize,
          pageSizes = _this$props6.pageSizes,
          disabled = _this$props6.disabled,
          pageSizeLabel = _this$props6.pageSizeLabel,
          goToPage = _this$props6.goToPage,
          pageSizeDropdownProps = _this$props6.pageSizeDropdownProps,
          _ = _this$props6.intl.formatMessage;
      var items = (0, _utils.convertPageSizes)(pageSizes);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-pagination-page-size"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "page-size-label"
      }, pageSizeLabel || _(_sbPaginationI18n.messages.pageSizeLabel)), /*#__PURE__*/_react.default.createElement(_sbDropdown.SbDropdown, _extends({}, pageSizeDropdownProps, {
        selected: pageSize.toString(),
        items: items,
        onChange: _this.handleOnPageSizeChange,
        disabled: disabled,
        size: (_pageSizeDropdownProp = pageSizeDropdownProps.size) !== null && _pageSizeDropdownProp !== void 0 ? _pageSizeDropdownProp : 's'
      })), goToPage && _this.renderGoToPage(_this.getChunks().length < 2));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNavigation", function () {
      var _this$props7 = _this.props,
          pageNumber = _this$props7.pageNumber,
          maxPreviousPages = _this$props7.maxPreviousPages,
          maxNextPages = _this$props7.maxNextPages,
          previousLabel = _this$props7.previousLabel,
          nextLabel = _this$props7.nextLabel,
          buttonClassName = _this$props7.buttonClassName,
          disabled = _this$props7.disabled,
          _ = _this$props7.intl.formatMessage;

      var chunks = _this.getChunks();

      var displayedChunks = (0, _utils.retrievePageNumbers)({
        pageNumber: pageNumber,
        chunks: chunks,
        maxPreviousPages: maxPreviousPages,
        maxNextPages: maxNextPages
      });
      var buttonsClassName = (0, _classnames.default)('sb-width-xs', 'sb-pagination-controls-button', buttonClassName);

      var pageButtons = _this.renderPageButtons({
        displayedChunks: displayedChunks,
        buttonsClassName: buttonsClassName
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-pagination-navigation"
      }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: function onClick() {
          _this.handleOnNavigationChange({
            value: -1,
            isControl: true
          });
        },
        className: (0, _classnames.default)(buttonsClassName, 'no-border', 'increment-button'),
        disabled: disabled || pageNumber === 1 || displayedChunks.length === 0
      }, previousLabel || _(_sbPaginationI18n.messages.previousLabel)), pageButtons, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: function onClick() {
          _this.handleOnNavigationChange({
            value: 1,
            isControl: true
          });
        },
        className: (0, _classnames.default)(buttonsClassName, 'no-border', 'increment-button'),
        disabled: disabled || pageNumber === chunks.length || displayedChunks.length === 0
      }, nextLabel || _(_sbPaginationI18n.messages.nextLabel)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageButtons", function (_ref3) {
      var displayedChunks = _ref3.displayedChunks,
          buttonsClassName = _ref3.buttonsClassName;
      var _this$props8 = _this.props,
          pageNumber = _this$props8.pageNumber,
          disabled = _this$props8.disabled;

      if (displayedChunks.length === 0) {
        return _this.renderPageButton({
          number: 1,
          isCurrent: true,
          buttonsClassName: buttonsClassName,
          disabled: disabled
        });
      }

      return displayedChunks.map(function (page) {
        var number = page.number,
            spacer = page.spacer;
        return _this.renderPageButton({
          number: number,
          isCurrent: pageNumber === number,
          buttonsClassName: buttonsClassName,
          disabled: disabled,
          spacer: spacer
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageButton", function (_ref4) {
      var number = _ref4.number,
          isCurrent = _ref4.isCurrent,
          buttonsClassName = _ref4.buttonsClassName,
          disabled = _ref4.disabled,
          spacer = _ref4.spacer;

      if (spacer) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-pagination-spacer",
          key: "".concat(_this.instanceId, "-").concat(number)
        }, "...");
      }

      return /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: function onClick() {
          _this.handleOnNavigationChange({
            value: number
          });
        },
        className: (0, _classnames.default)(buttonsClassName, {
          'no-border': !isCurrent
        }),
        disabled: disabled,
        key: "".concat(_this.instanceId, "-").concat(number)
      }, number);
    });

    _this.state = {
      goToPageValue: ''
    };
    _this.instanceId = (0, _v.default)();
    return _this;
  }

  _createClass(_SbPagination, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props9 = this.props,
          className = _this$props9.className,
          id = _this$props9.id,
          style = _this$props9.style;
      var rest = (0, _utils.extractRestFromProps)(this.props);
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
        className: (0, _classnames.default)('sb-pagination', className),
        style: style,
        id: id
      }), this.renderControls());
    }
  }]);

  return _SbPagination;
}(_react.PureComponent);

exports._SbPagination = _SbPagination;

_defineProperty(_SbPagination, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  pageSize: _propTypes.default.number,
  pageNumber: _propTypes.default.number,
  totalCount: _propTypes.default.number,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  pageSizes: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape(pageSizesShape)])),
  pageSizeDropdownProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  goToPage: _propTypes.default.bool,
  maxPreviousPages: _propTypes.default.number,
  maxNextPages: _propTypes.default.number,
  onChange: _propTypes.default.func,
  previousLabel: _propTypes.default.string,
  nextLabel: _propTypes.default.string,
  pageSizeLabel: _propTypes.default.string,
  goToPageLabel: _propTypes.default.string,
  goToPageInputProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  buttonClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool
});

_defineProperty(_SbPagination, "defaultProps", {
  pageSize: 10,
  pageNumber: 0,
  totalCount: 0,
  className: null,
  id: null,
  style: {},
  pageSizes: [10, 25, 50, 100],
  pageSizeDropdownProps: {},
  goToPage: true,
  maxPreviousPages: 2,
  maxNextPages: 2,
  onChange: NOOP,
  previousLabel: null,
  nextLabel: null,
  pageSizeLabel: null,
  goToPageLabel: null,
  goToPageInputProps: null,
  buttonClassName: null,
  disabled: false
});

var SbPagination = (0, _reactIntl.injectIntl)(_SbPagination);
exports.SbPagination = SbPagination;
//# sourceMappingURL=sb-pagination.js.map